import { Component } from '@angular/core';
import { DataService } from '../service/data.service';
import { Router, RouterModule } from '@angular/router';
import { FormioModule } from '@formio/angular';
import { CommonModule } from '@angular/common';
import { environment } from '../../environments/environment';
import {
  HttpClientModule,
  HttpClient,
  HttpHeaders,
} from '@angular/common/http';
import { LoadingService } from '../service/loading.service';
import { forkJoin } from 'rxjs'; 

@Component({
  selector: 'app-family-list',
  standalone: true,
  imports: [RouterModule, FormioModule, HttpClientModule, CommonModule],
  templateUrl: './family-list.component.html',
  styleUrls: ['./family-list.component.css'],
})
export class FamilyListComponent {
  response: any; // Original response
  baseUrl!: string;
  projecturl!: string;
  errorMessage: string | null = null;
  linkExpired: boolean = false;

  constructor(
    private dataService: DataService,
    private router: Router,
    private http: HttpClient,
    private loadingService: LoadingService
  ) {}

  ngOnInit(): void {
    this.baseUrl = environment.BASE_URL;
    this.projecturl = environment.PROJECT_URL;
    this.fetchSubmissions();
  }
  handleNavigation() {
    if (
      this.response.length == 1 &&
      this.response[0].data.localStatus === 'Appointment-Booked'
    ) {
      this.dataService.changeData(this.response[0]);
      this.router.navigate([`/new-intake/${this.response[0]._id}`]);
    } else if(this.response.length == 0){
    
      this.router.navigate(['new-intake']);
    }
    else {
      this.router.navigate(['family-list']);
    }
    
  }
  fetchSubmissions() {
    if (this.projecturl !== undefined) {
      const token = localStorage.getItem('formioToken') || '';
      const headers = new HttpHeaders({ 'x-jwt-token': token });

      if (token === '') {
        this.router.navigate(['new-intake']);
        return;
      }

      this.loadingService.show();


      const v20Request = this.http.get<any[]>(`${this.projecturl}/intakev20/submission`, { headers });
      const oldRequest = this.http.get<any[]>(`${this.projecturl}/intakeform/submission`, { headers });

      forkJoin([v20Request, oldRequest]).subscribe({
        next: ([submissionsV20, submissionsOld]) => {
          console.log(`Retrieved ${submissionsV20.length} new and ${submissionsOld.length} old submissions.`);
          
          const combinedSubmissions = [...submissionsV20, ...submissionsOld];

          combinedSubmissions.sort((a, b) => {
            return new Date(b.created).getTime() - new Date(a.created).getTime();
          });

          this.processSubmissions(combinedSubmissions, token);
        },
        error: (error) => {
          console.error("Error fetching data from server", error);
          if (error?.status === 440 || error?.status === 401) {
            this.linkExpired = true;
          } else {
            this.errorMessage = 'Error fetching data from server';
          }
          this.loadingService.hide();
        }
      });
    }
  }

 private processSubmissions(submissions: any[], token: string) {
  localStorage.setItem('formioToken', token);
  this.response = submissions; 

  if (this.response && this.response.length === 1 && this.response[0].data.localStatus === 'Appointment-Booked') {
    this.onClick(this.response[0]); 
  } 
  else if (this.response.length === 0) {
    this.router.navigate(['new-intake']);
  }
  
  this.loadingService.hide();
}
  // addNew(event: any): void {
  //   this.dataService.changeData(event);
  //   this.router.navigate(['new-intake']);
  // }

onClick(patient: any): void {
  console.log("Selected patient:", patient);

  localStorage.setItem('email_address', patient.data?.patientEmail || '');
  localStorage.setItem('clinic_code', patient.data?.selectChiroCenter || '');
  localStorage.setItem('created_date', patient.created || '');
  localStorage.setItem('formId', patient.form || '');

  this.dataService.changeData(patient);

  this.router.navigate([`new-intake/${patient._id}`]);
}
}